import CategoryNavigation from 'components/CategoryNavigation';
import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import Text from 'components/Text';
import { useIsEditing } from 'hooks';
import type { AssetResponse } from 'models/asset';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';

interface Category {
	href: string;
	icon?: AssetResponse;
	id: string;
	text: string;
}

interface Props extends SitecoreBlockProps {
	fields?: {
		categories?: Category[];
		heading?: Field<string>;
	};
}

export default function ShortcutCategories({ fields, params }: Props) {
	const isEditing = useIsEditing();

	if (!fields) {
		return null;
	}

	if (isEditing) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="ShortcutCategories"
				deprecated="Deadline April 26, 2027 [DP-10033]"
			/>
		);
	}

	const items = filterTruthy(
		fields.categories?.map((cat) => ({
			href: cat.href,
			text: cat.text,
			imageSrc: cat.icon?.src,
		})),
		'href',
		'text',
	);

	if (!fields.heading?.value || items.length === 0) {
		return null;
	}

	return (
		<LayoutContainer outerClassName={getEditorMargin(params)}>
			<Text
				as={params?.heading || 'h2'}
				field={fields.heading}
				className="mb-4"
			/>
			<CategoryNavigation className="mb-4" items={items} />
		</LayoutContainer>
	);
}
ShortcutCategories.displayName = 'ShortcutCategories';
